<div class='customer-information-form' id="customer-information-form">
  <div class="alert-error">
    <app-alert-error></app-alert-error>
  </div>
  <div *ngIf="!showLoading">
    <div id="information-heading">
      <form [formGroup]="personalInformationFormGroup" *ngIf="showPersonalInfoSection">
        <div class="row">
          <div class="col-md-12">
            <h4><strong>{{cfetLabels.cfet_customer_information.tell_more_about_label}}</strong></h4>
            <label for="send-info-content"
              id='send-info-content'>{{cfetLabels.cfet_customer_information.where_to_send_info_content}}</label>
            <label for="info-content" id='info-content'>{{cfetLabels.cfet_customer_information.info_content}}</label>
          </div>
        </div>

        <div class="row form-row" id="firstname-input" [class.error]="!isValidFirstName">
          <div class="col-md-12">
            <label for="firstname">{{cfetLabels.cfet_customer_information.firstname}}</label>
            <div class="firstname-inputbox">
              <input id="input_first_name" class="firstname" name="input_first_name" formControlName="firstName"
                aria-label="First name" autocomplete="off" restrict-input="restrictforName" maxlength="256" type="text"
                (blur)="checkFirstname()">
              <div *ngIf="!isValidFirstName" role="alert" [attr.aria-atomic]="true"
                [ngClass]="{'error-msg' : (!isValidFirstName)}">
                <em class="icon-badgealert" aria-hidden="true"></em>
                <span *ngIf="!isValidFirstName">{{cfetMessages.first_name_error}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row" id="middlename-input">
          <div class="col-md-12">
            <label for="middlename">{{cfetLabels.cfet_customer_information.middlename}}</label>
            <label for="optional" id="optional">{{cfetLabels.cfet_customer_information.optional}}</label>
            <div class="middlename-inputbox">
              <input id="input_middle_name" class="middlename" name="input_middle_name" formControlName="middleName"
                aria-label="Middle name / initial" autocomplete="off" restrict-input="restrictforName" maxlength="256"
                type="text">
            </div>
          </div>
        </div>

        <div class="row form-row" id="lastname-input" [class.error]="!isValidLastName">
          <div class="col-md-12">
            <label for="lastname">{{cfetLabels.cfet_customer_information.lastname}}</label>
            <div class="lastname-inputbox">
              <input id="input_last_name" class="lastname" name="input_last_name" formControlName="lastName"
                aria-label="Last name" autocomplete="off" restrict-input="restrictforName" maxlength="256" type="text"
                (blur)="checkLastname()">
              <div *ngIf="!isValidLastName" role="alert" [attr.aria-atomic]="true"
                [ngClass]="{'error-msg' : (!isValidLastName)}">
                <em class="icon-badgealert" aria-hidden="true"></em>
                <span *ngIf="!isValidLastName">{{cfetMessages.last_name_error}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-row" id="address1-input" [class.error]="personalAddErrorFlag">
          <div class="col-md-12">
            <label for="address1">{{cfetLabels.cfet_customer_information.address1}}
              <span id="line1-desc"> {{cfetLabels.cfet_customer_information.line1}}</span>
            </label>
            <div class="address1-inputbox">
              <input id="address1" class="address1" name="address1" tabindex="0" formControlName="address1Val"
                maxlength="256" type="text" aria-label="Home address line 1" autocomplete="off" (blur)="checkAddress()">
              <div *ngIf="personalAddErrorFlag" role="alert" [attr.aria-atomic]="true"
                [ngClass]="{'error-msg' : personalAddErrorFlag}">
                <em class="icon-badgealert" aria-hidden="true"></em>
                <span *ngIf="personalAddErrorFlag">{{cfetMessages.address_line}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row" id="address2-input">
          <div class="col-md-12">
            <label for="address2" id="address2-label">{{cfetLabels.cfet_customer_information.address2}}</label>
            <span id="line2-desc"> {{cfetLabels.cfet_customer_information.line2}}</span>
            <label for="optional" id="optional">{{cfetLabels.cfet_customer_information.optional}}</label>
            <div class="address2-inputbox">
              <input id="address2" class="address2" name="address2" tabindex="0" formControlName="address2Val"
                maxlength="256" type="text" aria-label="Home address line 2" autocomplete="off">
            </div>
          </div>
        </div>

        <div class="row form-row" id="city-input" [class.error]="cityErrorFlag">
          <div class="col-md-12">
            <label for="city">{{cfetLabels.cfet_customer_information.city}}</label>
            <div class="city-inputbox">
              <input id="city" class="city" name="city" tabindex="0" formControlName="cityVal" maxlength="40"
                type="text" aria-label="City" autocomplete="off" restrict-input="restrictforModalCity"
                (blur)="checkCity()">
              <div *ngIf="cityErrorFlag" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (cityErrorFlag)}">
                <em class="icon-badgealert" aria-hidden="true"></em>
                <span *ngIf="cityErrorFlag">{{cfetMessages.city}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row" id="row-dropdown">
          <div class="col-md-12">
            <label for="select_state">{{cfetLabels.cfet_customer_information.state}}</label>
            <div class="field-group">
              <div [ngClass]="checkStateVal ? 'dropdown-opened' : ''">
                <abs-dropdown [drId]="'select_state'" [drName]="'stateValue'" [(dropdownValue)]="stateValOption"
                  formControlName="stateValue" [optionRepeat]="stateListArr" (dropdownValueChange)="onChangeState($event)"
                  (click)="onClickState($event)" ngDefaultControl>
                </abs-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-row" id="zipcode-input" [class.error]="zipcodeError">
          <div class="col-md-12">
            <label for="zipcode">{{cfetLabels.cfet_customer_information.zipcode}}</label>
            <div class="zipcode-inputbox">
              <input id="zipcode" class="zipcode" name="zipcode" tabindex="0" formControlName="zipCode" maxlength="10"
                type="text" restrict-input="restrictzipcode" aria-label="Zipcode" autocomplete="off"
                (blur)="checkZip()">
              <div *ngIf="zipcodeError" role="alert" [attr.aria-atomic]="true"
                [ngClass]="{'error-msg' : (zipcodeError)}">
                <em class="icon-badgealert" aria-hidden="true"></em>
                <span *ngIf="zipcodeError">{{cfetMessages.valid_zipcode}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-row" id="mobileno-input" [class.error]="phoneNumberErr">
          <div class="col-md-12">
            <label for="mobileno">{{cfetLabels.cfet_customer_information.mobilenumberControl}}</label>
            <div class="mobileno-inputbox">
              <input id="mobileno" class="mobileno" name="mobileno" tabindex="0" formControlName="mobilenumberControl"
                maxlength="10" type="text" placeholder="000-000-0000" appPhoneMask autocomplete="off"
                (blur)="checkPhoneNumber()">
              <div *ngIf="phoneNumberErr" role="alert" [attr.aria-atomic]="true"
                [ngClass]="{'error-msg' : phoneNumberErr}">
                <em class="icon-badgealert" aria-hidden="true"></em>
                <span *ngIf="phoneNumberErr">{{cfetMessages.mobile_number_error}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-row" id="dob-input" [class.error]="(!isValidDob || (isValidDob && customerAge<16))">
          <div class="col-md-12">
            <label for="dob">{{cfetLabels.cfet_customer_information.dob}}</label>
            <div class="dob-inputbox">
              <input id="dob" class="dob" name="dob" tabindex="0" formControlName="dateOfBirthFcontrol" maxlength="10"
                type="text" placeholder="MM/DD/YYYY" restrict-input="dob" autocomplete="off" (keyup)="formatDOB($event)"
                (blur)="checkDOB()">
            </div>
            <div *ngIf="!isValidDob || (isValidDob && customerAge<16)"
              [ngClass]="{'error-msg': (!isValidDob || (isValidDob && customerAge<16))}" role="alert"
              [attr.aria-atomic]="true">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="!isValidDob">{{cfetMessages.dob_error}}</span>
              <span *ngIf="isValidDob && customerAge<16">{{cfetMessages.personal_info_dob_error}}</span>
            </div>
          </div>
        </div>

        <div class='row' id="personal-email-msg" *ngIf="showPersonalEmailDesc">
          <div class='label-txt col-md-12'>
            <p><strong>{{cfetLabels.cfet_customer_information.personal_email_heading}}</strong></p>
          </div>
        </div>

        <div class="row form-row" id="email-input"
          [class.error]="(emailAddressError || emailAddressEmpty || emailAlreadyExistsFlag)">
          <div class="col-8"><label for="email">{{cfetLabels.cfet_customer_information.personalemail}}</label></div>
          <div class="col-4"> <label for="userid" id="userid">{{cfetLabels.cfet_customer_information.userid}}</label>
          </div>
          <div class="col-md-12 email-inputbox">
            <input id="email" class="email" name="email" tabindex="0" formControlName="emailAddress" maxlength="256"
              placeholder="" type="text" restrict-input="restrictEmailforSpace"
              (blur)="validateEmailAddr('personal')" (change)="onChangeEmail()" #inputEmail autocomplete="off">
            <div *ngIf="emailAddressError || emailAddressEmpty || emailAlreadyExistsFlag" role="alert"
              [attr.aria-atomic]="true"
              [ngClass]="{'error-msg' : (emailAddressError || emailAddressEmpty || emailAlreadyExistsFlag)}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="emailAddressError">{{cfetMessages.valid_email}}</span>
              <span *ngIf="emailAddressEmpty">{{cfetMessages.empty_email}}</span>
              <span *ngIf="emailAlreadyExistsFlag">{{cfetMessages.email_exists1}}
                <a id="login-page" (click)="redirectToLogin($event)" (keyup)="redirectToLogin($event)"
                  tabindex="0">login</a>
                {{cfetMessages.email_exists2}}</span>
            </div>
          </div>
        </div>

        <div class='yes-no-button-group row'>
          <div class='label-txt col-md-12'>
            <p>
              {{cfetLabels.cfet_customer_information.verification_heading1}}{{cfetLabels.cfet_customer_information.verification_heading4}}
              <strong>{{workDept}}</strong>
              {{cfetLabels.cfet_customer_information.verification_heading2}}
            </p>
          </div>

          <div class='col-md-6 mobile-styling'>
            <button type="button" class="confirm-btn" id="confirm-btn-yes" tabindex="0"
              (click)="hasWorkEmail($event,'yes')" (keyup)="hasWorkEmail($event,'yes')"
              [ngClass]="(selectedconfirmValue==='Yes') ? 'confirm-color-change' : ''">{{cfetButtonLabels.button_labels.yes}}</button>
          </div>
          <div id='no-button' class='col-md-6 mobile-styling'>
            <button type="button" class="confirm-btn" id="confirm-btn-no" tabindex="0"
              (click)="hasWorkEmail($event,'no')" (keyup)="hasWorkEmail($event,'no')"
              [ngClass]="(selectedconfirmValue==='No') ? 'confirm-color-change' : ''">{{cfetButtonLabels.button_labels.no}}</button>
          </div>
        </div>

        <div class="row form-row" id="workemail-input" *ngIf="showWorkEmail" [class.error]="workEmailAddressError">
          <div class="col-8">
            <label for="workemail">{{cfetLabels.cfet_customer_information.workemail}}</label>
          </div>
          <div class="col-4">
            <label for="optional" id="optional-email">{{cfetLabels.cfet_customer_information.optional}}</label>
          </div>
          <div class="email-inputbox col-md-12">
            <input id="workemail" class="workemail" name="workemail" tabindex="0" formControlName="workEmailAddress"
              maxlength="256" placeholder="" type="text" (blur)="validateEmailAddr('work')"
              restrict-input="restrictEmailforSpace" autocomplete="off">
            <div *ngIf="workEmailAddressError" role="alert" [attr.aria-atomic]="true"
              [ngClass]="{'error-msg' : workEmailAddressError}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="workEmailAddressError">{{cfetMessages.valid_email}}</span>
            </div>
          </div>
        </div>

        <div class='emp-or-vol-checker row'>
          <div class='label-txt col-md-12'>
            <p>{{cfetLabels.cfet_customer_information.verification_heading1}}
              <strong>{{workDept}}</strong>
              {{cfetLabels.cfet_customer_information.verification_heading3}}
            </p>
          </div>

          <div class='col-md-6 mobile-styling'>
            <button type="button" class="confirm-btn" id="confirm-btn-yes" tabindex="0"
              (click)="hasWorkIDNumber($event,'yes')" (keyup)="hasWorkIDNumber($event,'yes')"
              [ngClass]="(selectedEmpIdButton==='Yes') ? 'confirm-color-change' : ''">{{cfetButtonLabels.button_labels.yes}}</button>
          </div>
          <div id='no-button' class='col-md-6 mobile-styling'>
            <button type="button" class="confirm-btn" id="confirm-btn-no" tabindex="0"
              (click)="hasWorkIDNumber($event,'no')" (keyup)="hasWorkIDNumber($event,'no')"
              [ngClass]="(selectedEmpIdButton==='No') ? 'confirm-color-change' : ''">{{cfetButtonLabels.button_labels.no}}</button>
          </div>
        </div>

        <div class="row form-row" id="workidnumber-input" *ngIf="showWorkIdNumberinput" [class.error]="workIdError">
          <div class="col-8">
            <label for="workidnumber">{{cfetLabels.cfet_customer_information.check_id_number}}</label>
          </div>
          <div class="col-4">
            <label for="optional" id="optional-email">{{cfetLabels.cfet_customer_information.optional}}</label>
          </div>
          <div class="email-inputbox col-md-12">
            <input id="workidnumber" class="workidnumber" name="workidnumber" tabindex="0"
              formControlName="workidnumber" maxlength="256" placeholder="" type="text"
              restrict-input="restrictIdforSpace" autocomplete="off">
            <div *ngIf="workIdError" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : workIdError}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="workIdError">{{cfetMessages.valid_employee_id}}</span>
            </div>
          </div>
        </div>

        <div class="row" id="customerInfo-footer-column1">
          <div id="customerInfo-footer-buttons">
            <div class="col-md-12">
              <button type="button" id="btn-submit" (click)="submit($event)" (keyup)="submit($event)"
                class="btn btn-alt btn-medium" tabindex="0" [disabled]="disabledSubmitButton">
                {{cfetButtonLabels.button_labels.submit}}</button>
            </div>

            <div class="col-md-12">
              <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
                type="button" id="cancel_link" class="btn btn-secondary btn-clear cancel_link">
                {{cfetButtonLabels.button_labels.cancel}}</a>
            </div>
          </div>
        </div>
      </form>

      <div class="row" id="customer-instant-verification-container" *ngIf="showInstantVerificationSection">
        <div class="col-md-12" id="customer-instant-verification">
          <app-customer-instant-verification (setNewSession)="setNewSession($event)"
            (showCancelModal)="displayCancelModal($event)"></app-customer-instant-verification>
        </div>
      </div>

      <div class="row" id="customer-verification-notrequired-container" *ngIf="showVerificationNotRequired">
        <div class="col-md-12" id="customer-verification-notrequired">
          <app-customer-verification-notrequired (setNewSession)="setNewSession($event)"
            (showCancelModal)="displayCancelModal($event)">
          </app-customer-verification-notrequired>
        </div>
      </div>

      <div class="row" id="customer-documents-upload-container" *ngIf="showDocUploadSection">
        <div class="col-md-12" id="customer-documents-upload">
          <app-customer-documents-upload (goToDocReceived)="goToDocReceived($event)"
            [selectedWorkPlace]="selectedWorkPlace" [fname]="fname" [lname]="lname">
          </app-customer-documents-upload>
        </div>
      </div>

      <div class="row" id="customer-verification-pending-container" *ngIf="showVerificationPending">
        <div class="col-md-12" id="customer-verification-pending">
          <app-customer-verification-pending (goToDocUpload)="goToDocUpload($event)">
          </app-customer-verification-pending>
        </div>
      </div>

      <div class="row" id="customer-document-review-container" *ngIf="showDocReviewPending">
        <div class="col-md-12" id="doc-review-pending">
          <app-customer-documents-review (setNewSession)="setNewSession($event)"></app-customer-documents-review>
        </div>
      </div>

    </div>
  </div>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>
